<div *transloco="let t; prefix: 'dod-skill-categories-mobile-filter'" class="mobile-filters">
  <header>
    <div>
      <button
        data-cy="btn-close-filters"
        accredible-button-icon
        icon="chevron-left"
        iconSize="20px"
        (click)="closeFilters()"></button>

      <h1>{{ t('filters') }}</h1>
    </div>

    @if (_skillCategories.selectedSkillCategories().length > 0) {
      <button
        data-cy="btn-clear-filters"
        class="btn-clear-filters"
        accredible-button-icon
        (click)="selectedSkillCategoriesChange([])">
        {{ t('clear_filters') }}
      </button>
    }
  </header>

  <div class="cf-content-horizontal mobile-filters-content">
    <accredible-multi-search-filter
      [label]="t('skills')"
      [placeholder]="t('search_skills')"
      [optionsLabelKey]="'name'"
      [options]="_skillCategories.skillCategories()"
      [selectedOptions]="selectedOptions()"
      [useMaxHeight]="true"
      (optionsChanged)="selectedSkillCategoriesChange($event)"
      (searchChanged)="queryChange($event)" />
  </div>

  <footer>
    <button
      data-cy="btn-apply-filters"
      accredible-button
      (click)="applyFilters()"
      [disabled]="!hasChanges()">
      {{ t('apply') }}
    </button>
  </footer>
</div>
